const SubTitle = ({ title, subTitle }) => {
  return (
    <div className="reg-section">
      <hr className="top-hr" />
      <p className="reg-title font-amaticsc-bold">{title}</p>
      <p className="reg-text font-zenkurenaido">{subTitle}</p>
      <hr className="bottom-hr" />
    </div>
  );
};

export default SubTitle;
